// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".industries-table {\n  background-color: white;\n}\n.industries-table .ant-table-pagination {\n  margin: 1rem;\n}\n.industries-table th.ant-table-cell.ant-table-selection-column .ant-table-selection {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
